module.exports = __webpack_public_path__ + "static/media/auto-square-slide.35ce857d.webp";